<card name="Modals">
  <div card content>
    <button class="btn btn-primary" (click)="open()">
      Open receipt details
    </button>
  </div>
</card>
